// tssStrengthUtils.js (o donde tengas calculateHrTSSStrength)

export const calculateHrTSSStrength = (
  avgHeartRate,
  // DEPRECATED en fuerza: thresholdHeartRate (se mantiene por compat)
  thresholdHeartRate,
  durationSeconds,
  // NUEVO: pásalo desde zones_target.max_heart_rate o profile.hrMax
  maxHeartRate
) => {
  if (!avgHeartRate || !durationSeconds) {
    console.warn("[calculateHrTSSStrength] Datos incompletos:", {
      avgHeartRate,
      thresholdHeartRate,
      maxHeartRate,
      durationSeconds,
    });
    return NaN;
  }

  const durationHours = durationSeconds / 3600;

  // 1) En fuerza: usar HRmax si existe
  const denom = maxHeartRate || thresholdHeartRate; // fallback por compat (pero no ideal)
  if (!denom) {
    console.warn("[calculateHrTSSStrength] Falta maxHeartRate (y thresholdHeartRate).");
    return NaN;
  }

  // 2) IF por HR (cap para evitar picos)
  let IF = avgHeartRate / denom;
  IF = Math.max(0, Math.min(IF, 0.90)); // cap 0.90 recomendado para fuerza

  // 3) hrTSS base
  const base = durationHours * IF * IF * 100;

  // 4) Escala conservadora para fuerza
  // Ajusta: 0.25–0.40 (empieza con 0.30)
  const STRENGTH_SCALE = 0.30;

  const hrTSS = base * STRENGTH_SCALE;

  return Number.isFinite(hrTSS) ? parseFloat(hrTSS.toFixed(2)) : NaN;
};

export default calculateHrTSSStrength;
